import React from 'react'

import { FlightSearchCard } from './FlightSearchCard'
import FlightSearchTileContent from './FlightSearchTileContent'
import SearchFlights from '../TripModal/TripItems/Search/SearchFlights'

import { useAirport } from 'tripPlanner/hooks/api'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { LEFlightItem } from 'tripPlanner/types/tripItem'

export interface Props {
  item: LEFlightItem
}

export default function FlightWithAirportsTile({ item }: Props) {
  const openModal = useOpenModal()
  const { originAirportCode, destinationAirportCode, fareType } =
    item.savedItemData
  const { data: departureAirport } = useAirport({ code: originAirportCode })
  const { data: arrivalAirport } = useAirport({
    code: destinationAirportCode,
  })

  return (
    <FlightSearchCard
      onClick={() =>
        openModal(SearchFlights, {
          tripId: item.tripId,
          prefillData: {
            departureAirport,
            arrivalAirport,
            fareType,
          },
        })
      }
    >
      <FlightSearchTileContent item={item} />
    </FlightSearchCard>
  )
}
